import {
  type FC
} from 'react';
import {
  Stack,
  Typography,
  styled
} from '@mui/joy';
import {
  ChosenCoinPackageCard,
  type CoinPackage,
} from '@entities/coins';

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '24px',
  fontStyle: 'normal',
  color: theme.palette.common.white
}));

export type TitleBlockProps = {
  coinPackage?: Maybe<CoinPackage>;
};

export const TitleBlock: FC<TitleBlockProps> = ({ coinPackage }) => (
  <Stack
    width='100%'
    rowGap={1.5}
    alignItems='center'
    justifyContent='center'>
    <TitleText>
      You have successfully redeemed:
    </TitleText>
    {coinPackage && (
      <ChosenCoinPackageCard
        viewMode
        darkMode
        data={coinPackage}
      />
    )}
  </Stack>
);